/**
 * api接口统一管理
 *
 */
import {
    post, get, Header, del, put,getFile, postToken
} from './http';
export const rootPath = '';
//用户登录接口
export const loginUser = (params) => get(Header.client + `/user/login?${params}`);
//用户权限
export const userPrivileges = (params) => get(Header.client + `/user/findUserPermission`, params);
//获取token接口
export const findToken = () => get(Header.client + `/user/accessToken`);
//企业组查询
export const findGroupCompany = () => get(Header.client + `/company/findGroupCompany`);
//查询上市企业行业
export const listIndustry = industryId => get(Header.client + `/company/findCompanyByIndustryId?industryId=${industryId}`);
//企业名称查询
export const findCompanyByName = name => get(Header.client + `/company/findCompanyByName?name=${name}`);
export const findCompanyOne = () => get(Header.client + `/company/findCompanyOne`);
//跳转企业详情接口
export const companyDetailNews = (params) => get(Header.client + `/company/findCompanyInfo?id=${params.id}`);
//企业文章相关推荐
export const contentCompany = (params) => get(Header.client + `/company/contentRecommend`, params);
//英文名称的检验
export const testEnglish = (params) => get(Header.client + `/company/checkCompanyENName`, params);
//中文名称的检验
export const testChinese = (params) => get(Header.client + `/company/checkCompanyZHName`, params);
//海外舆情搜索
export const overseasPublic = (params) => post(Header.client + `/news/findNews?${params}`);
//新闻详情查询
export const newsDetail = (params) => get(Header.client + `/news/findNewsInfo?id=${params.id}`);
//获取新闻媒体来源ID
export const newsID = (params) => get(Header.client + `/news/findSourceList?companyId=${params.companyId}`);
//品牌声量趋势
export const brandVolume = (params) => get(Header.client + `/analysis/brandMedia?companyId=${params.companyId}&dateType=${params.dateType}&startTime=${params.startTime}&endTime=${params.endTime}`);
//用户关注声量
export const userAttention = (params) => get(Header.client + `/analysis/userAttention?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//查询ES国家列表
export const listofCountries = (params) => get(Header.client + `/analysis/findESCountry?companyId=${params.companyId}`);
//情绪分布柱状图
export const emotionalBarchart = (params) => get(Header.client + `/analysis/emotionalBar?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//情绪分布饼图
export const emotionalPiechart = (params) => get(Header.client + `/analysis/emotionalPie?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//情感趋势
export const feelingTrend = (params) => get(Header.client + `/analysis/emotionalMovements?companyId=${params.companyId}`);
//舆论活跃度分析柱状图
export const activePublic = (params) => get(Header.client + `/analysis/activityPublicOpinionBar?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//舆论活跃度分析饼图
export const activePublicPie = (params) => get(Header.client + `/analysis/activityPublicOpinionPie?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//舆论活跃度折线图
export const activePublicLine = (params) => get(Header.client + `/analysis/activityPublicOpinionLine?companyId=${params.companyId}&startTime=${params.startTime}&endTime=${params.endTime}`);

//行业列表信息
export const industryList = () => get(Header.client + `/analysis/findIndustryList`);
//热点词云图
export const wordPicture = (params) => get(Header.client + `/analysis/popularWordCloud?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//首页词云图
export const homeWordPicture = (params) => get(Header.client + `/analysis/home/popularWordCloud?companyId=${params.companyId}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//行业地狱分布
export const regionalHeat = (params) => get(Header.client + `/analysis/regionalHeat?companyId=${params.companyId}&startTime=${params.startTime}&endTime=${params.endTime}`)
//品牌热度排行
export const brandHeat = (params) => get(Header.client + `/analysis/brandRanking?companyIds=${params.companyIds}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//品牌热度排行折线图
export const brandLine = (params) => get(Header.client + `/analysis/brandRankingLine?companyId=${params.companyId}&companyIds=${params.companyIds}&startTime=${params.startTime}&endTime=${params.endTime}`)
//export const brandHeat = (params) => get(Header.client + `/analysis/brandRanking?companyNames=${params.companyNames}&regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//行业地域分布
export const industryArea = (params) => get(Header.client + `/analysis/regionalIndustry?regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`);
//行业活跃度
export const industryActivity = (params) => get(Header.client + `/analysis/industryActivity?regionalNames=${params.regionalNames}&startTime=${params.startTime}&endTime=${params.endTime}`)
//企业信息详情
export const companyDetail = (params) => get(Header.client + `/company/findCompanyInfo`, params);
//删除企业信息
export const delCompanyInfo = id => del(Header.client + `/company/deleteCompanyInfo?id=${id}`)
//增加企业信息
export const addComapny = (params) => post(Header.client + `/company/addCompanyInfo`, params);
//查询行业列表
export const industry = () => get(Header.client + `/company/findIndustryList`);
//更新企业状态
export const updateState = (params) => get(Header.client + `/company/updateCompanyStatus`, params);
//编辑更新企业
export const infoUpdate = (params) => put(Header.client + `/company/updateCompanyInfo`, params)
//查询角色列表
export const roleList = (params) => get(Header.client + `/role/findRoleList`, params);
export const userRoleList = () => get(Header.client + `/role/findAllRole`);
//删除角色
export const deleteRole = (params) => del(Header.client + `/role/deleteRoleById`, params);
//查询权限树
export const permissionTree = () => get(Header.client + `/permission/findPermissionTree`);
//添加角色基本信息
export const roleMessage = (params) => post(Header.client + '/role/addRoleInfo', params);
//查询角色详细信息
export const roleDetail = (params) => get(Header.client + `/role/findRoleById`, params);
//检查角色名是否重复
export const repeatRole = (params) => get(Header.client + `/role/checkRoleName`, params);
//修改你角色基本信息
// export const updateRole = (params) => put(Header.client + `/role/updateRoleInfo`, params);
//更新角色状态
export const roleState = (params) => put(Header.client + `/role/updateRoleStatus?${params}`);
//用户信息列表
export const userList = (params) => get(Header.client + `/user/findUserList`, params);
//用户状态更新
export const updateUserState = (params) => put(Header.client + `/user/updateUserStatus?${params}`);
//用户关联品牌更新
export const brandUpdate = (params) => put(Header.client + `/user/updateUserCompany`, params);
//用户关联品牌查询
export const brandSearch = (params) => get(Header.client + `/user/findUserCompany`, params);
//用户关联角色更新
export const userRoleUpdate = (params) => put(Header.client + `/user/updateUserRole`, params);
//用户关联角色查询
export const roleSearch = (params) => get(Header.client + `/user/findUserRole`, params);
//消息预警数量
// export const earlyWarningNumber = (params) => get(Header.client + `/message/findMessageCount`, params);
// //消息预警列表
// export const earlyWarningList = (params) => get(Header.client + `/message/findMessageList`, params);
//消息信息状态更新
export const updateEarlyStatus = (params) => put(Header.client + `/message/updateMessageStatus?${params}`);
// 海外舆情
export const getNewsList = (params) => post(Header.client + `/news/findNewsData?${params}`);
//状态
export const updateStatus = (params) => post(Header.client + `/news/updateNewsStatus?${params}`);
//状态
export const getEmotionalList = () => get(Header.client + `/news/findEmotionalList`);
// 审核状态
export const updateEmoStatus = (params) => post(Header.client + `/news/updateNewsScore?${params}`);
//查询企业组列表
export const companyGroup = () => get(Header.client + `/group/findGroupList`);
//分页查询组列表
export const queryGroup = (params) => get(Header.client + `/group/findGroupPage`, params);
//删除组信息
export const deleteGroup = (params) => del(Header.client + `/group/deleteGroup`,params);
//添加组信息
export const addGroup = (params) => post(Header.client + `/group/addGroup`, params);
//检查组英文名是否重复
export const repeatEgropu = (params) => get(Header.client + `/group/checkENName`, params);
//检查组中文名是否重复
export const repeatCgroup = (params) => get(Header.client + `/group/checkZHName`, params);
//按照id查询组信息
export const groupList = (params) => get(Header.client + `/group/findGroupById`, params);
//修改组信息
export const updateGroup = (params) => put(Header.client + `/group/updateGroup`, params);
//获取企业名称
export const companyName = (params) => get(Header.client + `/company/getCompanyName?id=${params.id}`);
/**
 * @description 主页相关
 */
export const getTotal = ()=>get(Header.client+'/analysis/dataStatistics');

export const getHomeCountry = () => get(Header.client + '/analysis/findAllESCountry');

//下载监控网站
// export const downLoads = (brandToken) => {
//     location.href = Header.client + `/analysis/downloadWebSitesData?brandToken=${brandToken}`
// };

export const downLoad = () => getFile(Header.client + `/analysis/downloadWebSitesData`);

//品牌统计 -> 情感列
export const emotionList = () => get(Header.client + `/base/getEmotionList`)
// 品牌统计 -> 大洲列
export const continentList = () =>  get(Header.client + `/base/getRegionList`)
// 品牌统计 -> 国家列（通过洲获取）
export const countryList = (params) => get(Header.client + `/base/getCountryByRegion`, params)
// 品牌统计 -> 媒体列（通过国家获取）
export const mediaList = (params) => get(Header.client + `/base/getSiteByCountry`, params)
// 品牌统计列表
export const brandStatistics = (params) => postToken(Header.client + `/statistics/brandStatistics`, params)
// 品牌情感统计
export const brandEomtionStatistics = (params) => postToken(Header.client + `/statistics/brandEmotionStatistics`, params)
// 媒体数量详情
export const brandSiteStatistics = (params) => postToken(Header.client + `/statistics/brandSiteStatistics`, params)
// 品牌新闻详情
export const emotionDetail = (params) => postToken(Header.client + `/statistics/brandNewsDetail`, params)
// 品牌新闻详情
export const brandTopStatistics = (params) => postToken(Header.client + `/statistics/brandTopStatistics`, params)

